<template>

  <div class="az_base_box">
    <div class="az_crud_ttl">
      <div class="az_crud_ttl_left" style="display: flex; justify-content: space-between; width: 100%">
        <h3 class="az_crud_ttl_txt">{{ title }}</h3>
        <button @click="videoModal=true" class="video-instruction-btn">
          <svg data-v-01dd24c7="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
            <path fill="currentColor"
                  d="M8.667 2.167h-4c-2.28 0-3.167.887-3.167 3.167v5.333c0 1.533.833 3.167 3.167 3.167h4c2.28 0 3.166-.887 3.166-3.167V5.334c0-2.28-.886-3.167-3.166-3.167"
                  opacity=".4"></path>
            <path fill="currentColor"
                  d="M7.667 7.587a1.253 1.253 0 1 0 0-2.507 1.253 1.253 0 0 0 0 2.507M14.434 4.114c-.274-.14-.847-.3-1.627.246l-.987.694c.007.093.014.18.014.28v5.333c0 .1-.014.187-.014.28l.987.693c.413.294.773.387 1.06.387.247 0 .44-.067.567-.133.273-.14.733-.52.733-1.474V5.587c0-.953-.46-1.333-.733-1.473"></path>
          </svg>
          {{ $t('videoInstruction') }}
        </button>
      </div>
    </div>


    <div class="az_crud_ftr" data-custom-accordion v-if="filterShow">

      <div class="az_crud_ftr_cnt" data-custom-accordion-body>
        <div class="az_crud_ftr_cnt_inr">
          <div class="d-flex flex-wrap">
            <div class="az_crud_ttl_right" v-if="createShow">

            </div>
            <slot name="filter" v-if="$slots.hasOwnProperty('filter')">SLOT: 'filter'</slot>

          </div>
        </div>
      </div>
    </div>


    <slot name="table" v-if="$slots.hasOwnProperty('table')">SLOT: 'table'</slot>


    <div class="az_crud_nav_ft">
      <div v-if="footerShow">
        <slot name="pagination" v-if="$slots.hasOwnProperty('pagination')">SLOT: 'pagination'</slot>
      </div>
    </div>
    <VideoModal
        videoUrl="https://www.youtube.com/embed/O4jH3T1ljM0"
        :isVisible="videoModal"
        @close="videoModal = false"
    />
  </div>

</template>

<script>
import {required} from "vuelidate/lib/validators";
import VideoModal from './VideoInstruction.vue';

const notZero = (value) => +value !== 0;

export default {
  name: 'BaseCrudPageList',
  components: {
    VideoModal
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    createUrl: {
      type: Object,
      required: true,
    },
    createShow: {
      type: Boolean,
      default: true,
    },
    filterShow: {
      type: Boolean,
      default: true,
    },
    filterOpen: {
      type: Boolean,
      default: true,
    },
    footerShow: {
      type: Boolean,
      default: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object, Array],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showOrganization: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      videoModal: false,
      projectList: [],
      columnList: [],
      recordList: this.resource,
    };
  },
  validations() {
    let options = {
      model: {
        name: {
          required,
        },
      }
    };


    if (!this.edit) {
      options.model.projectId = {
        notZero,
      };

      // options.model.columnId = {
      // 	notZero,
      // };

      if (this.$store.state.userProfile.systemAdmin) {
        options.model.organizationId = {
          notZero,
        };
      }
    }

    return options;
  },
  watch: {
    'model.organizationId'(val) {
      if (this.edit) {
        return;
      }

      this.model.projectId = 0;
      this.projectList = [];

      if (val) {
        this.getProjectList(val);
      }
    },
    'model.projectId'(val) {
      if (this.edit) {
        return;
      }

      this.model.columnId = 0;
      this.columnList = [];

      if (val) {
        // this.getColumnList(val);
      }
    },
    'resource'(val) {
      this.recordList = val;
    },
  },
  mounted() {
    // this.getProjectList(0);
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('emit:submit');
    },
    getProjectList(organizationId) {
      this.$api
          .get('projects/projects', {
            params: {
              organizationId: organizationId,
            }
          })
          .then(response => {
            this.projectList = response.data.data;
          });
    },
    getColumnList(projectId) {
      this.$api
          .get('projectColumns/selection', {
            params: {
              projectId: projectId,
            }
          })
          .then(response => {
            this.columnList = response.data.data;
          });
    },
    GetList() {
      this.$api
          .get('projects/projects')
          .then(response => {
            this.recordList = response.data.data;
          });
    },
    created() {
      if (!this.external) {
        // this.GetList();
      }
    },
  },
  computed: {
    // eslint-disable-next-line vue/no-dupe-keys
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', val);
      }
    }
  },

};
</script>

<style>
.video-instruction-btn {
  border: none;
  padding: 0 12px;
  border-radius: 6px;
  background: #0096b21f;
  user-select: none;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0096b2;
  gap: 12px;
  margin-right: 12px;
  transition: all 0.3s ease;
}

.video-instruction-btn:hover {
  background: #0096b2;
  color: #fff;
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 30px 0px;
}
</style>
